import { useState } from 'react';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const faqs = [
  {
    question: '¿Acualys-Bo funciona sin internet?',
    answer: 'Sí. El sistema principal funciona localmente en tu computadora. La sincronización online es opcional y se activa cuando tienes conexión para publicar datos al servidor y habilitar el portal web de afiliados y la app del lecturador.',
  },
  {
    question: '¿Puedo importar mis datos actuales de Excel?',
    answer: 'Absolutamente. Acualys-Bo incluye herramientas de importación para migrar tu base de afiliados, historial de lecturas y saldos desde archivos Excel o CSV. Te acompañamos en el proceso de migración.',
  },
  {
    question: '¿Los afiliados pueden ver su deuda online?',
    answer: 'Sí. Al sincronizar con el servidor online, cada afiliado accede a su cuenta privada donde consulta su historial de consumo, pagos realizados, deuda actual y ubicación de su conexión en el mapa.',
  },
  {
    question: '¿El lecturador necesita instalar una app?',
    answer: 'No necesita instalar nada. El lecturador accede a una URL privada desde el navegador de su celular, toma la foto del medidor, registra la lectura y queda todo sincronizado automáticamente.',
  },
  {
    question: '¿Qué pasa con la seguridad de mis datos?',
    answer: 'Acualys-Bo incluye auditoría completa de cada acción, respaldo SQL exportable de toda la base de datos, y sincronización cifrada con el servidor online. Tus datos están bajo tu control en todo momento.',
  },
  {
    question: '¿El sistema se adapta a las tarifas de mi cooperativa?',
    answer: 'Sí. Las tarifas son completamente configurables: defines categorías (A, B, C), montos por m³, límites, pagos fijos, multas automáticas y descuentos. Además, el histórico de vigencias queda guardado.',
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const { ref: sectionRef, isVisible } = useScrollReveal<HTMLDivElement>();

  return (
    <section id="faq" className="relative py-20 md:py-28 bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div ref={sectionRef} className="max-w-3xl mx-auto">
          {/* Header */}
          <div className={`text-center mb-14 md:mb-18 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-800 text-sm font-semibold mb-4">
              Resolvemos tus dudas
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-primary-900">
              Preguntas frecuentes
            </h2>
          </div>

          {/* FAQ items */}
          <div className="space-y-4">
            {faqs.map((faq, i) => (
              <div
                key={i}
                className={`bg-background-50 border border-background-200 rounded-xl overflow-hidden transition-all duration-500 hover:border-primary-200 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
                style={{ transitionDelay: `${(i + 1) * 100}ms` }}
              >
                <button
                  onClick={() => setOpenIndex(openIndex === i ? null : i)}
                  className="w-full flex items-center justify-between gap-4 p-5 md:p-6 text-left cursor-pointer"
                  aria-expanded={openIndex === i}
                >
                  <span className="font-heading text-sm md:text-base font-semibold text-foreground-900">
                    {faq.question}
                  </span>
                  <div className={`shrink-0 w-8 h-8 rounded-full bg-primary-50 flex items-center justify-center transition-all duration-300 ${openIndex === i ? 'bg-accent-500 text-white rotate-180' : 'text-primary-600'}`}>
                    <i className="ri-arrow-down-s-line text-lg" />
                  </div>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-500 ${openIndex === i ? 'max-h-[500px]' : 'max-h-0'}`}
                >
                  <div className="px-5 md:px-6 pb-5 md:pb-6">
                    <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}